import { TableCard } from '../../../../components'
import { ListFiltersProvider } from '../core/ListFiltersProvider'
import { QueryRequestProvider } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { NotasVersaoListHeader } from './components/header/NotasVersaoListHeader'
import { NotasVersaoTable } from './table/NotasVersaoTable'

const NotasVersaoList = () => (
  <TableCard>
    <NotasVersaoListHeader />
    <NotasVersaoTable />
  </TableCard>
)

export const NotasVersaoListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <NotasVersaoList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
